import { Navigate } from "react-router-dom";
import { CalendarClock, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function AccessEnded() {
  const { user, loading, logout } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.is_admin || user.access_state === "active") return <Navigate to="/parent" replace />;
  if (user.access_state === "survey_required") return <Navigate to="/survey" replace />;

  return (
    <div className="min-h-screen bg-[#EAF7F4] font-parent text-slate-900 flex items-center justify-center px-5">
      <div className="max-w-md w-full nb-card bg-white p-8 text-center">
        <div className="w-16 h-16 rounded-2xl bg-amber-300 border-4 border-slate-900 flex items-center justify-center mx-auto mb-4">
          <CalendarClock size={30} />
        </div>
        <h1 className="text-2xl font-bold">Pilot access has ended</h1>
        <p className="text-slate-600 mt-3 text-sm">Thank you so much for testing Anou Appran during the launch pilot. Your access window has now closed.</p>
        <p className="text-slate-600 mt-2 text-sm">We'd love to continue supporting your child — please get in touch with us to renew your access and unlock more subjects and grades.</p>
        <button onClick={logout} data-testid="access-ended-logout" className="mt-6 rounded-full border-2 border-slate-900 px-5 py-2.5 font-semibold inline-flex items-center gap-2 hover:bg-slate-50">
          <LogOut size={16} /> Log out
        </button>
      </div>
    </div>
  );
}
